var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C12.0333 0 9.13319 0.879735 6.66645 2.52796C4.19972 4.17618 2.27713 6.51886 1.14181 9.25975C0.00649941 12.0006 -0.290551 15.0166 0.288228 17.9264C0.867006 20.8361 2.29562 23.5088 4.3934 25.6066C6.49119 27.7044 9.16394 29.133 12.0737 29.7118C14.9834 30.2906 17.9994 29.9935 20.7403 28.8582C23.4812 27.7229 25.8238 25.8003 27.4721 23.3336C29.1203 20.8668 30 17.9667 30 15C29.9982 11.0223 28.4172 7.20809 25.6046 4.39545C22.7919 1.5828 18.9777 0.00185495 15 0ZM15 2C17.5712 2 20.0846 2.76244 22.2224 4.1909C24.3603 5.61935 26.0265 7.64968 27.0104 10.0251C27.9944 12.4006 28.2518 15.0144 27.7502 17.5362C27.2486 20.0579 26.0105 22.3743 24.1924 24.1924C22.3743 26.0105 20.0579 27.2486 17.5362 27.7502C15.0144 28.2518 12.4006 27.9944 10.0251 27.0104C7.64968 26.0265 5.61936 24.3603 4.1909 22.2224C2.76244 20.0846 2.00001 17.5712 2.00001 15C2.0016 11.5527 3.37175 8.247 5.80937 5.80937C8.247 3.37174 11.5527 2.00159 15 2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2929 11.293L14.9999 16.586L9.70692 11.293C9.51832 11.1108 9.26571 11.0101 9.00352 11.0123C8.74132 11.0146 8.49051 11.1198 8.3051 11.3052C8.11969 11.4906 8.01452 11.7414 8.01224 12.0036C8.00997 12.2658 8.11076 12.5184 8.29292 12.707L14.2929 18.707C14.4804 18.8945 14.7348 18.9998 14.9999 18.9998C15.2651 18.9998 15.5194 18.8945 15.7069 18.707L21.7069 12.707C21.8024 12.6148 21.8786 12.5044 21.931 12.3824C21.9834 12.2604 22.011 12.1292 22.0122 11.9964C22.0133 11.8636 21.988 11.7319 21.9377 11.6091C21.8875 11.4862 21.8132 11.3745 21.7193 11.2806C21.6254 11.1867 21.5138 11.1125 21.3909 11.0622C21.268 11.0119 21.1363 10.9866 21.0035 10.9878C20.8707 10.9889 20.7395 11.0165 20.6175 11.0689C20.4955 11.1213 20.3852 11.1975 20.2929 11.293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.66257416ddc1a34193a7c574787b98ee.svg";
export { ForwardRef as ReactComponent };